<div class="row">
    <div class="col-12 card p-5 shadow">
        <div class="row">
            <div class="col-12 mb-5 d-flex ">
                <div id="login-logo"></div>
                <div id="login-title">
                    AudiWEB
                </div>
            </div>
        </div>
        <!-- <div class="row my-3">
            <div class="col-12 d-flex">
                <mapfre-auditlib-select [form]="form.get('domain')" label="{{ 'FORM.AUTH.LABELS.DOMAIN' | translate}}" [data]="domainList" field="show" selectionMode="simple" [readonly]="readonly" [placeholder]="'FORM.AUTH.LABELS.DOMAIN.SELECT'" icon="icon-24-px-chevron color-primary"
                    class="w-100 font-large">
                </mapfre-auditlib-select>
            </div>
        </div>
        <div class="row">
            <div class="col-12 d-flex ">
                <mapfre-auditlib-input [form]="form.get('user')" label="FORM.AUTH.LABELS.USER" icon="icon-24-px-chevron color-primary" class="w-100 font-large">
                </mapfre-auditlib-input>
            </div>
        </div>
        <div class="row">
            <div class="col-12 d-flex mt-3">
                <mapfre-auditlib-input [form]="form.get('password')" icon="icon-24-px-chevron color-primary" label="FORM.AUTH.LABELS.PASSWORD" type="password" class="w-100 font-large">
                </mapfre-auditlib-input>
            </div>
        </div> -->
        <div class="row">
            <div class="col-6 mt-5 d-flex font-medium-large greyish-brown justify-content-start  align-items-center">
                <!--Incidencia 201 Estado resuelta, se ha añadido un mailto en audiweb-->
                <a href="mailto:DAUDITMAPSOP@mapfre.com" target="_blank">{{'LOGIN.HELP'| translate }}</a>
            </div>
            <div class="col-6 mt-5 d-flex justify-content-end align-items-center">
                <mapfre-auditlib-button (click)="onEnterClick()">
                    <div class="pe-3 ps-3">{{ 'FORM.GENERIC_LABELS.ENTER' | translate }}</div>
                </mapfre-auditlib-button>
            </div>
        </div>
    </div>
</div>